import React from 'react';
import { connect } from 'react-redux';

import '../styles/Playlist.css';

function Playlist(props) {
  return (
    <div className='Playlist' >
      Coming soon.
    </div>
  );
}

function mapStateToProps(reduxState) {
  return ({
    
  });
}

export default connect(mapStateToProps, {
  
})(Playlist);